import _extends from "@babel/runtime/helpers/esm/extends";
import { getUrlParams, handleParmas } from '../utils/util';

/** dataStatistics 监测统计
 * @param {object | string} options（必填）  传入类型为string默认为event_type
 * @param {string} options.event_type（非必填）  事件类型 click | view
 * @param {string} options.page_title(非必填)  页面标题
 *
 * @param {string} event_key（非必填）点击事件名称
 * @param {object} json（非必填）如需keywords或者其他自定义字段可在这里传入。
 */
var install = {
  install: function install(Vue, config) {
    var dataStatistics = function dataStatistics(options, event_key, json) {
      var userInfo = {
        user_id: config.setUserId ? config.setUserId() : '',
        unionid: config.setUnionid ? config.setUnionid() : '',
        openid: config.setOpenid ? config.setOpenid() : ''
      };
      if (config.setMixinJson) {
        json = _extends({}, config.setMixinJson(), json);
      }
      var $localStorage = window.localStorage;
      // 如果有注入自定义的$localStorage优先使用自定义的$localStorage
      if (Vue.prototype.$localStorage) {
        $localStorage = Vue.prototype.$localStorage;
      }
      var query = getUrlParams();
      var _url = window.location.href || '';
      var _page_title = document.title || '';
      var event_type = '';
      if (typeof options == 'object') {
        event_type = options.event_type || 'view';
        _page_title = options.page_title || _page_title;
      } else {
        event_type = options || 'view';
      }
      var params = _extends({
        type: 1,
        user_id: userInfo.id,
        unionid: userInfo.unionid || $localStorage.getItem('unionid') || '',
        openid: userInfo.openid || $localStorage.getItem('openid') || '',
        page_title: _page_title,
        page_description: undefined,
        page_url: encodeURIComponent(_url),
        page_referer_url: undefined,
        page_param: query,
        page_event_key: event_key || undefined,
        // 当是点击事件的时候，这里需要传点击按钮的文案。
        page_event_type: event_type || 'view',
        // view = 浏览  click = 点击   share = 分享
        wechat_user_name: config.monitor.user_name,
        wechat_appid: config.appid
      }, json);
      Vue.axios.post(config.monitor.url, handleParmas(params)).then(function () {});
    };
    if (!Vue.prototype.$dataStatistics) {
      Vue.prototype.$dataStatistics = dataStatistics;
    }
    Vue.directive('monitor', {
      bind: function bind(el, binding, vnode) {
        var _ref = binding.value || {},
          event_type = _ref.event_type,
          page_title = _ref.page_title,
          event_key = _ref.event_key,
          custom = _ref.custom;
        if (typeof binding.value != 'object') {
          event_key = binding.value;
        }
        el.setAttribute('data-monitor', event_key);
        var onclick = function onclick(event) {
          event.stopPropagation();
          vnode.context.$emit(binding.expression, event);
          var options = null;
          if (event_type || page_title) {
            options = {
              event_type: event_type || 'click',
              page_title: page_title || document.title
            };
          }
          dataStatistics(options ? options : 'click', event_key, custom);
        };
        el.addEventListener('click', onclick);
      }
    });
    Vue.mixin({
      beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function () {
          if (!to.meta.closeMonitorView && config.monitor.autoView) {
            dataStatistics();
          }
        });
      },
      created: function created() {
        Vue.prototype.$dataStatistics = Vue.prototype.$dataStatistics;
      }
    });
  }
};
export default install;